export default [
  {
    order: 5,
    name: "Leave Allowance",
    icon: "fact_check",
    to: "/leaveallowance/list",
    enabled: true,
  },
];
